'use client'

import { Icon } from '@circlefin/components/lib/Icon'
import { Link } from '@features/common.components/Link'
import { TextLink } from '@features/common.components/TextLink'
import { toggleOneTrustInfoDisplay } from '@features/common.utils/oneTrust'
import Image from 'next/image'
import useTranslation from 'next-translate/useTranslation'

export const Footer = () => {
  const { t } = useTranslation('common')
  return (
    <div className="flex w-full flex-col items-center justify-center space-y-4 text-center text-xs lg:flex-row lg:justify-between lg:space-y-0">
      <div className="flex flex-row items-center justify-center space-x-4">
        <Link path="/legal/developer-terms" type="console">
          {t('footer.links.developerTerms')}
        </Link>
        <Link path="/legal/service-terms" type="console">
          {t('footer.links.serviceTerms')}
        </Link>
        <Link
          path="https://www.circle.com/en/legal/privacy-policy"
          type="external"
        >
          {t('footer.links.privacyPolicy')}
        </Link>
        <TextLink
          href="#"
          onClick={toggleOneTrustInfoDisplay}
          size="xs"
          variant="primary"
        >
          {t`footer.links.privacyPolicyChoice`}
          <Image
            alt={t`footer.links.privacyPolicyChoice`}
            className="inline self-center"
            height={30}
            src="/images/PrivacyOptions.svg"
            width={30}
          />
        </TextLink>
      </div>
      <div className="flex flex-row items-center justify-center space-x-4">
        <Link path="https://discord.com/invite/buildoncircle" type="external">
          <Icon name="Social/Discord" size={32} />
        </Link>
        <Link path="https://twitter.com/BuildOnCircle" type="external">
          <Icon name="Social/X-Twitter" size={32} />
        </Link>
        <Link
          path="https://www.youtube.com/playlist?list=PLoJwRn8qrG24wgM802HEDGtzfIL6D9PYW"
          type="external"
        >
          <Icon name="Social/Youtube" size={32} />
        </Link>
      </div>
    </div>
  )
}
